import classNames from "classnames";

import styles from "./PatternChips.module.css";

/** Path globs as mono chips; an em dash when there are none. */
export function PatternChips({
  patterns,
  variant = "include",
}: {
  patterns: readonly string[];
  variant?: "include" | "exclude";
}) {
  if (patterns.length === 0) {
    return <span className={styles.none}>&mdash;</span>;
  }
  return (
    <span className={styles.chips}>
      {patterns.map((pattern) => (
        <code
          key={pattern}
          className={classNames(styles.chip, {
            [styles.exclude]: variant === "exclude",
          })}
        >
          {pattern}
        </code>
      ))}
    </span>
  );
}
